module.exports = __webpack_public_path__ + "static/img/LUCAS-ROBINSON.bfd08d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LUCAS-ROBINSON.jpg
// module id = Cbvc
// module chunks = 0